import { Quote } from "lucide-react";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { useLanguage } from "@/hooks/use-language";
import LazyVimeo from "./LazyVimeo";

const CustomerTestimonial = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const { t } = useLanguage();

  return (
    <section className="py-32 lg:py-44 bg-navy relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-gold/10 rounded-full blur-[150px] -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-gold/5 rounded-full blur-[120px] translate-x-1/2 translate-y-1/2" />
      
      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-16">
            <span className="inline-block text-gold text-sm font-bold uppercase tracking-widest mb-4">
              {t("Kundberättelse", "Customer story")}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-normal text-white mb-6">
              {t("Vad våra kunder säger", "What our customers say")}
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative group">
              <div className="aspect-video rounded-2xl border border-white/10 shadow-xl overflow-hidden">
                <LazyVimeo
                  src="https://player.vimeo.com/video/748759690?dnt=1&title=0&byline=0&portrait=0"
                  title={t("Kundberättelse - Philip Maazon, Wall to Wall Group", "Customer story - Philip Maazon, Wall to Wall Group")}
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-br from-gold/30 to-gold/10 rounded-2xl -z-10" />
            </div>

            <div className="relative">
              <Quote className="absolute -top-4 -left-4 w-16 h-16 text-gold/20" />
              <div className="relative z-10">
                <h3 className="text-2xl md:text-3xl font-display text-white mb-6">
                  {t(
                    "Philip Maazon från Wall to Wall Group delar med sig av sin upplevelse som kund hos oss på Tiego",
                    "Philip Maazon from Wall to Wall Group shares his experience as a customer at Tiego"
                  )}
                </h3>
                <p className="text-lg text-white/70 leading-relaxed mb-8">
                  {t(
                    "Se gärna filmen med Philip Maazon, Finanschef på Wall to Wall Group som berättar om hur han upplevt implementationsprocessen och övergången till en effektivare koncernredovisning.",
                    "Watch the video with Philip Maazon, CFO at Wall to Wall Group, who shares how he experienced the implementation process and the transition to a more efficient group accounting."
                  )}
                </p>
                <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gold/30 to-gold/10 flex items-center justify-center text-white font-display text-xl">PM</div>
                  <div>
                    <p className="text-white font-semibold">Philip Maazon</p>
                    <p className="text-white/60 text-sm">{t("Finanschef, Wall to Wall Group", "CFO, Wall to Wall Group")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerTestimonial;
